module.exports = __webpack_public_path__ + "img/pencil-outline.8439bb80.svg";